export default [
	{  // 生产计划单列表
		path: 'plan',
		name: 'm_plan',
		meta: {
			templateManage: {
				workType: 2,
				print: 'b_plan_printtemplate',
				export: 'b_plan_exporttemplate'
			},
			appView: {
				viewId: '90024',
				detailView: [{
					name: '详情-产品明细',
					viewId: '90025'
				}],
				auth: 'b_plan_viewmanage'
			}
		},
		props: route => route.query,
		component: () => import('@/pages/production/plan_list')
	},
	{  // 装配工单列表
		path: 'assemble',
		name: 'm_assemble',
		meta: {
			templateManage: {
				workType: 34,
				print: 'b_assemble_printtemplate',
				export: 'b_assemble_exporttemplate'
			},
			appView: {
				viewId: '90022',
				detailView: [{
					name: '详情-产品明细',
					viewId: '90023'
				}],
				auth: 'b_assemble_viewmanage'
			}
		},
		component: () => import('@/pages/production/assemble_list')
	},
	{  // 工单列表
		path: 'work',
		name: 'm_work',
		meta: {
			templateManage: {
				workType: 3,
				print: 'b_work_printtemplate',
				export: 'b_work_exporttemplate'
			},
			appView: {
				viewId: '90003',
				detailView: [{
					name: '详情-生产进度',
					viewId: '90012'
				}, {
					name: '详情-用料清单',
					viewId: '90013'
				}, {
					name: '分享-生产进度',
					viewId: '90032'
				}],
				auth: 'b_work_viewmanage'
			}
		},
		component: () => import('@/pages/production/work_list')
	},
	{  // 任务列表
		path: 'task',
		name: 'm_task',
		meta: {
			templateManage: {
				workType: 13,
				print: 'b_task_printtemplate',
				export: 'b_task_exporttemplate'
			},
			appView: {
				viewId: '90001',
				detailView: [{
					name: '详情-报工记录',
					viewId: '90015'
				}],
				auth: 'b_task_viewmanage'
			}
		},
		props: route => route.query,
		component: () => import('@/pages/production/task_list')
	},
	{  // 报工列表
		path: 'output',
		name: 'm_output',
		meta: {
			templateManage: {
				workType: 14,
				print: 'b_output_printtemplate',
				export: 'b_output_exporttemplate'
			},
			appView: {
				viewId: '90010',
				baseInfo: false,
				extendView: [{
					name: '报工记录',
					viewId: '90002'
				}],
				auth: 'b_output_viewmanage'
			}
		},
		props: route => route.query,
		component: () => import('@/pages/production/output_list')
	},
	{  // 报工工作台
		path: 'outputWorkbench',
		name: 'm_output_workbench',
		component: () => import('@/pages/production/output_workbench')
	},
	{  // 排产日历
		path: 'schedule',
		name: 'm_schedule_calendar',
		props: route => route.query,
		component: () => import('@/pages/production/schedule')
	},
	{  // 烘烤批次
		path: 'bakeTask',
		name: 'm_bake_task',
		meta: {
			templateManage: {
				workType: 72,
				export: 'b_bake_task_exporttemplate'
			},
			appView: {
				viewId: '90072',
				auth: 'b_bake_task_viewmanage'
			}
		},
		component: () => import('@/pages/production/bake_task_list')
	}
];